import { render } from "./PanelCommandeStep2Register.vue?vue&type=template&id=938c312c"
import script from "./PanelCommandeStep2Register.vue?vue&type=script&lang=js"
export * from "./PanelCommandeStep2Register.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jonathanthomas/Documents/Sites/vuejs/gr2022-phase-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__